import { render, staticRenderFns } from "./Articledetail.vue?vue&type=template&id=1ec431c5"
import script from "./Articledetail.vue?vue&type=script&lang=js"
export * from "./Articledetail.vue?vue&type=script&lang=js"
import style0 from "./Articledetail.vue?vue&type=style&index=0&id=1ec431c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports